import React, { useEffect, useState } from 'react'
import Web3 from 'web3';
import { ethers } from 'ethers';
import Countdown from 'react-countdown';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function Index() {
    const [showSelectOption, setShowSelectOption]= useState(true);
    const [paidAsset, setPaidAsset]= useState("BNB");
    const [connected, setConnected]= useState(false);
    const [wallet, setWallet]= useState("");
    const [amount, setAmount]= useState("0");
    const web3 = new Web3(new Web3.providers.HttpProvider('https://bsc-dataseed.binance.org/'));
    const [masterData, setMasterData] = useState({});
    const [rateBNB, setBNBPrice] = useState('0');
    const [availableBalance, setAvailableBalance] = useState('0');
    const [kcoinAmount, setKcoinAmount] = useState('0');
    const [isButton, setButton] = useState(true);
    const [inputValue , setInputValue] = useState('0');

   const usdtContractAddressData = "0x55d398326f99059fF775485246999027B3197955"; // Replace with yo
   const usdtAbiData = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
   
   const KcoinContractAddressData = "0x5D26acBA14e4840cbce7B3504B90bb9B9f1Ca99B"; // Replace with yo
   const kcoinAbiData = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];
 

 
    const icoStartDate = new Date("2025-03-15T00:00:00");

    const [selectedAsset, setSelectedAsset] = useState({
        name: "BNB",
        image: "https://cryptologos.cc/logos/binance-coin-bnb-logo.png",
      });
    
      const assets = [
        { name: "BNB", image: "https://cryptologos.cc/logos/binance-coin-bnb-logo.png" },
        { name: "USDT", image: "https://cryptologos.cc/logos/tether-usdt-logo.png" },
      ];


      useEffect(() => {
        

        fetchMasterData();
        getBalance();
        getBnbBalance();
      }, []);
    
      const connectWallet = async () => {
        if (!window.ethereum) {
          alert("MetaMask not found! Please install MetaMask.");
          return;
        }
    
        try {
          const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
          setWallet(accounts[0]);
          getBnbBalance(accounts[0]);
          setConnected(true);
        } catch (error) {
          console.error("Connection failed:", error);
        }
      };  


   const showSelect =()=>{
    setShowSelectOption(false);
   }
   const slectAsset = (asset) =>{
    setAmount(0);
    setPaidAsset(asset)
    if(asset === 'BNB'){
        setSelectedAsset({name: "BNB", image: "https://cryptologos.cc/logos/binance-coin-bnb-logo.png"})

        getBnbBalance(wallet);
    }
    if(asset === 'USDT'){
        setSelectedAsset({ name: "USDT", image: "https://cryptologos.cc/logos/tether-usdt-logo.png" })

        getTokenBalance(wallet);
    }
    setShowSelectOption(true)
   }

   const inputAmount = (enteredAmount) =>{
    setAmount(enteredAmount);

    if(selectedAsset.name === 'BNB'){
        const KcoinInBNB = rateBNB*enteredAmount/masterData.ico_current_price;
        setKcoinAmount(KcoinInBNB)
        setInputValue(rateBNB*enteredAmount);
    }

    if(selectedAsset.name === 'USDT'){
        const KcoinInBNB = 1*enteredAmount/masterData.ico_current_price;
        setKcoinAmount(KcoinInBNB)
        setInputValue(enteredAmount);
    }
   }


    const fetchMasterData = async () => {
        try {
          const response = await fetch("https://kaymcoin.com/api/ico/masterData.php", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });
  
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
  
          const result = await response.json();
          setMasterData(result.data);
       //   console.log('Master Data',result.data);
        } catch (error) {
        //  setError(error.message);
        } finally {
        //  setLoading(false);
        }
      };


      const getBalance = async (symbol) => {
        const apiUrl = `https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT`;
        try {
            const response = await fetch(apiUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            if (data && data.price) {
                const price = data.price;
              //  console.log(`Token Price: $${price}`);
              setBNBPrice(price);
            } else {
             //   console.error('Unexpected API response:', data);
            }
        } catch (error) {
           // console.error('Error fetching token price:', error.message);
        }
      }


      const getBnbBalance  = async (wallet) =>{


        try {
           
         // Fetch the balance (returns in Wei)
         const balanceWei = await web3.eth.getBalance(wallet);
       
         // Convert balance from Wei to BNB
         const balanceBNB = web3.utils.fromWei(balanceWei, "ether");
       
         setAvailableBalance(balanceBNB)
      //   console.log('BNB Price ',balanceBNB );
       } catch (error) {
         console.error("Error fetching BNB balance:", error);
         return null;
       }
       }
       
       const getTokenBalance = async (wallet) => {
       
           const usdtContractAddress = usdtContractAddressData; // Replace with your USDT contract address
          const  tokenAbi = usdtAbiData; // Replace with your USDT ABI
       
       
         try {
           // Create token contract instance
           const tokenContract = new web3.eth.Contract(tokenAbi, usdtContractAddress);
       
           // Fetch balance
           const balance = await tokenContract.methods.balanceOf(wallet).call();
           const balanceUSDT = web3.utils.fromWei(balance, 'ether'); // Adjust based on token's decimals
       
           // Update state or perform any other action with the balance
           setAvailableBalance(balanceUSDT);
         //  console.log(`USDT Balance:`, balanceUSDT);
       
           return balanceUSDT; // Return the balance
         } catch (error) {
           console.error('Error fetching token balance:', error);
           return null; // Return null if an error occurs
         }
       };
  


 

   const   buyNow = async ()  =>{
    setButton(false);
    if (!wallet) {
      await connectWallet(); // Connect wallet if not connected
    }
  
    if (!amount || amount <= 0) {
      setButton(true);
      alert('Enter Valid Amount')
      return;
    }
  
    if(parseFloat(availableBalance) < parseFloat(amount)){
      setButton(true);
      alert('Insufficient Amount')
      return;
    }
  
    if(parseFloat(kcoinAmount) < parseFloat(masterData.minimum_buy_in_token)){
        setButton(true);
        alert(`Minimum Buy  ${masterData.minimum_buy_in_token} KTX`)
        return;
      }
  
    
        startTransfer(masterData.ico_wallet, wallet, selectedAsset.name,  amount, inputValue, masterData.ico_current_price, kcoinAmount, );
  }



  async function startTransfer(depositAddress, from_address, selectedCrypto, amount, inputValue, coin_price, receiveAmount) {
    try {
        // Initialize provider and signer
        if (!window.ethereum) throw new Error("MetaMask is not installed.");
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner(); 

       // console.log('ICO Start', depositAddress, from_address, selectedCrypto, amount, inputValue, coin_price, receiveAmount);

        if (selectedCrypto === "BNB") {
            // Handle BNB Transfer
            const amountInWei = ethers.parseUnits(amount.toString(), "ether");

            const tx = {
                to: depositAddress,
                value: amountInWei, // Amount in Wei
            };

            // Send transaction
            const transaction = await signer.sendTransaction(tx);
            await transaction.wait();

           // console.log("BNB Transfer Successful! Transaction Hash:", transaction.hash);
            // Update withdrawal
           createIco(depositAddress, from_address, selectedCrypto,  amount, inputValue, coin_price, receiveAmount,transaction.hash);

            return transaction;
        } else {
            // Handle USDT Transfer
            let usdtContractAddress, usdtAbi;

            if (selectedCrypto === "USDT") {
                usdtContractAddress = usdtContractAddressData; // Your USDT contract address
                usdtAbi = usdtAbiData; // Your USDT ABI
            } else {
                throw new Error("Unsupported cryptocurrency selected.");
            }

            // Create contract instance
            const usdtContract = new ethers.Contract(usdtContractAddress, usdtAbi, signer);

            const amountInToken = ethers.parseUnits(amount.toString(), 18); // Convert amount to token decimals

            // Send token transaction
            const transferTx = await usdtContract.transfer(depositAddress, amountInToken);
            await transferTx.wait();

//console.log(`${selectedCrypto} Transfer Successful! Transaction Hash:`, transferTx.hash);
           // Update withdrawal
        createIco(depositAddress, from_address, selectedCrypto,  amount, inputValue, coin_price, receiveAmount,transferTx.hash);
            return transferTx;
        }
    } catch (error) {
        console.error("Error during transfer:", error);
        alert("Transfer failed. Please try again.");
        return null;
    }
}




async function createIco(depositAddress, from_address, selectedCrypto,  amount, inputValue, coin_price, receiveAmount,txnHash){

 //  console.log('insert Data',depositAddress, from_address, selectedCrypto,  amount, inputValue, coin_price, receiveAmount,txnHash)
    try {
        const response = await fetch(`https://kaymcoin.com/api/ico/createIco.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              buying_asset: selectedCrypto,
              buying_amount: amount,
              buying_value: inputValue,
              token_price: coin_price,
              token_amount: receiveAmount,
              from_address: from_address,
              to_address: depositAddress,
              receiving_txn_hash: txnHash,
            }),
        });
  
        const data = await response.json();
     //   console.log('Stake Data',data);
        if (data.status) {
  
         receiveAsset(data.icoId, receiveAmount, from_address, data.icoWallet, data.ico_key);
  
         
       //   window.location.href = ""  
  
        } else {
         alert(data.message || "something went wrong.");
            setButton(true);
        }
    } catch (error) {
  
       console.error("Error during signin:", error);
      alert("An error occurred. Please try again later.");
        setButton(true);
    } finally {
       // setLoading(false); // Hide loader
    }
  
  }


  const receiveAsset = async (icoID, sentAmount, to_address, from_address, from_key) => {
    try {
        const securityKey = from_key;
        const amountTransfer = sentAmount.toString();

        // Get token contract instance
        const tokenContract = new web3.eth.Contract(kcoinAbiData, KcoinContractAddressData);

        // Convert the amount to Wei
        const TrValue = web3.utils.toWei(amountTransfer, 'ether');

        // Estimate gas
        let gasEstimate;
        try {
            gasEstimate = await tokenContract.methods.transfer(to_address, TrValue)
                .estimateGas({ from: from_address });
        } catch (err) {
            throw new Error('Gas estimation failed: ' + err.message);
        }

        // Get gas price
        let gasPrice;
        try {
            gasPrice = await web3.eth.getGasPrice();
        } catch (err) {
            gasPrice = web3.utils.toWei('10', 'gwei'); // Default to 10 Gwei
        }

        // Create transaction object
        const transactionObject = {
            from: from_address,
            to: KcoinContractAddressData, // Sending to contract address
            gas: gasEstimate, // FIXED: Using estimated gas instead of 21000
            gasPrice: gasPrice,
            data: tokenContract.methods.transfer(to_address, TrValue).encodeABI(),
        };

        // Sign the transaction
        const signedTransaction = await web3.eth.accounts.signTransaction(transactionObject, securityKey);

        // Send the signed transaction
        const receipt = await web3.eth.sendSignedTransaction(signedTransaction.rawTransaction);

        // Ensure transaction was successful
        if (!receipt || !receipt.transactionHash) {
            setButton(true); // FIXED: Moved before throwing error
            throw new Error("Transaction failed: No receipt received.");
        }

        const txnHash = receipt.transactionHash;
     //   console.log('KTX Sent Successfully', txnHash);

        // ✅ Update withdrawal status
        await updateIco(icoID, txnHash);

    } catch (error) {
        alert('Error in token transfer: ' + error.message);
    }
};

  

const updateIco = async (icoID, txnHash) => {

   // console.log('Update Data',icoID, txnHash)
    
    try {
        const response = await fetch(`https://kaymcoin.com/api/ico/updateIco.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ico_id: icoID.toString(),
                txn_hash: txnHash,
            })
        });
    
        const data = await response.json();
    
      //  console.log('ICO Update Response:', data);
    
        if (data && data.status) {
            window.location.href =""
        } else {
        }
    } catch (error) {
        console.error("Error during ICO update:", error);
        alert("An error occurred. Please try again later.");
    }
    };
    
  
  
 



    return (
        <>
            <div className="home-01">
                {/* Preloader */}
                {/* <div id="preloader">
                    <div className="spinner">
                        <div className="rect1" />
                        <div className="rect2" />
                        <div className="rect3" />
                        <div className="rect4" />
                        <div className="rect5" />
                    </div>
                </div> */}
                {/* Preloader */}
                {/* header-area */}
                <header id="header">
                    <div id="header-fixed-height" />
                    <div id="sticky-header" className="menu-area">
                        <div className="container custom-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="mobile-nav-toggler"><i className="fas fa-bars" /></div>
                                    <div className="menu-wrap">
                                        <nav className="menu-nav">
                                            <div className="logo">
                                                <a href="/"><img src="assets/img/logo/kcoinLogo.png" alt width={60} /></a>
                                            </div>
                                            <div className="navbar-wrap main-menu d-none d-lg-flex">
                                                <ul className="navigation">
                                                    <li className="active menu-item-has-children"><a href="#header" className="section-link">Home</a>
                                                       
                                                    </li>
                                                    <li><a href="#about" className="section-link">About us</a></li>
                                                    <li><a href="#sales" className="section-link">Sales</a></li>
                                                    <li><a href="#roadmap" className="section-link">Roadmap</a></li>
                                                    
                                                    <li><a href="#contact" className="section-link">Contact us</a></li>
                                                </ul>
                                            </div>
                                            <div className="header-action d-none d-md-block">
                                                <ul>
                                                    
                                                    <li className="header-btn"><a  onClick={connectWallet} className="btn">{wallet ? wallet.slice(0, 5) + '...' + wallet.slice(-5) : 'Connect Wallet'}</a></li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                    {/* Mobile Menu  */}
                                    <div className="mobile-menu">
                                        <nav className="menu-box">
                                            <div className="close-btn"><i className="fas fa-times" /></div>
                                            <div className="nav-logo"><a href="/"><img src="assets/img/logo/kcoinLogo.png" alt title /></a>
                                            </div>
                                            <div className="menu-outer">
                                                {/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}
                                            </div>
                                            <div className="social-links">
                                                <ul className="clearfix">
                                                    <li><a href="https://www.facebook.com/kaymcoin"><i className="fab fa-facebook-f" /></a></li>
                                                    <li><a href="https://twitter.com/kaymcoin"><i className="fab fa-twitter" /></a></li>
                                                    <li><a href="https://www.instagram.com/kaymcoin/"><i className="fab fa-instagram" /></a></li>
                                                    <li><a href="#"><i className="fab fa-linkedin-in" /></a></li>
                                                    <li><a href="https://www.youtube.com/channel/UCd39yTqnDn2DbFwC01lp3uw"><i className="fab fa-youtube" /></a></li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                    <div className="menu-backdrop" />
                                    {/* End Mobile Menu */}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                {/* header-area-end */}
                {/* main-area */}
                <main className="fix">
                    {/* banner-area */}
                    <section className="banner-area banner-bg">
                        <div className="banner-shape-wrap">
                            <img src="assets/img/banner/banner_shape01.png" alt className="img-one" />
                            <img src="assets/img/banner/banner_shape02.png" alt className="img-two" />
                            <img src="assets/img/banner/banner_shape03.png" alt className="img-three" />
                        </div>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10">
                                    <div className="banner-content text-center">
                                        <img src="assets/img/icon/fire.png" alt />
                                        <h2 className="title">Join Future of Algorithmic <span>Crypto</span> Ecosystem Network</h2>
                                    </div>
                                    <div className="banner-progress-wrap">
                                        <ul>
                                            <li>Pre Sell</li>
                                            <li>Soft Cap</li>
                                            <li>Bonus</li>
                                        </ul>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ "width": "0%" }} aria-valuenow={75} aria-valuemin={0} aria-valuemax={100} />
                                        </div>
                                        <h4 className="title">{masterData.phase_sale} K COIN Sold out <span>1 USDT =   {1/masterData.ico_current_price || '0'} K COIN</span></h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-xl-10">
                                    <div className="banner-countdown-wrap text-center">
                                        <h2 style={{fontSize:"40px"}} className="title text-warning">ICO Phase 1 End In</h2>
                                        <div className="coming-time">
                                             <h1 style={{fontSize:"60px"}}><Countdown date={icoStartDate} /></h1>   
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* banner-area-end */}
                    {/* about-area */}

                    <section id="buynow" className="about-area pt-130 pb-130">
                        <div className="container">
                            <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="about-img wow fadeInLeft" data-wow-delay=".2s">
                                    <Swiper  modules={[Navigation, Pagination, Autoplay]} spaceBetween={10} slidesPerView={1} navigation  pagination={{ clickable: true }} autoplay={{ delay: 3000 }} loop={true} className="image-slider" >
                                    <SwiperSlide>
                                        <img src="assets/img/banner/icoBanner1.jpeg" alt="KCoin Logo" />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src="assets/img/banner/icoBanner2.jpeg" alt="About Image" />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src="assets/img/banner/icoBanner3.jpeg" alt="Extra Image 1" />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src="assets/img/banner/icoBanner4.jpeg" alt="Extra Image 2" />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src="assets/img/banner/icoBanner5.jpeg" alt="Extra Image 2" />
                                    </SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                                <div className="col-lg-6">
                                    <div style={{ margin: "30px", padding: "30px", boxShadow: `
  0px 0px 15px rgba(0, 102, 255, 0.8), 
  0px 0px 30px rgba(0, 153, 255, 0.6), 
  0px 0px 45px rgba(0, 204, 255, 0.4)
`
, backgroundColor: "#0B1D33", borderRadius: "25px", animation: "burning 1.5s infinite alternate",}}>

                                        <div className="about-content wow fadeInRight" data-wow-delay=".2s">
                                            <div>
                                                <h5>Balance : {availableBalance ? availableBalance.slice(0, 10)  :  '..'} {selectedAsset.name}</h5>
                                                <span className="text-light">Lice price <b className="text-warning">{selectedAsset.name} = </b> $ {selectedAsset.name === 'BNB' ? rateBNB : "1"}</span>
                                            </div>
                                            <hr></hr>
                                            <div className="mt-2">

                                                <h4>Select Asset </h4>
                                                {showSelectOption ?(
                                                    <div className="mt-2" style={{  position: "relative", width: "100%", border: "1px solid #ccc", borderRadius: "5px", padding: "10px", background: "none", color: "#fff", cursor: "pointer",}} >
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }} onClick={showSelect}>
                                                        <img src={selectedAsset.image} alt={selectedAsset.name} style={{ width: "35px", height: "35px" }} />
                                                        <span style={{ fontSize: "25px" }}>{selectedAsset.name}  </span> 
                                                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                    
                                                ):(
                                                    <ul>
                                                        <li>
                                                        <div className="mt-2" style={{  position: "relative", width: "100%", border: "1px solid #ccc", borderRadius: "5px", padding: "10px", background: "none", color: "#fff", cursor: "pointer",}} >
                                                            <div style={{ display: "flex", alignItems: "center", gap: "30px" }} onClick={(e)=>slectAsset('BNB')}>
                                                                <img src="https://cryptologos.cc/logos/binance-coin-bnb-logo.png" alt="BNB" style={{ width: "35px", height: "35px" }} />
                                                                <span style={{ fontSize: "25px" }}>{"BNB"}</span>
                                                            </div>
                                                        </div>
                                                        </li>

                                                        <li>
                                                        <div className="mt-2" style={{  position: "relative", width: "100%", border: "1px solid #ccc", borderRadius: "5px", padding: "10px", background: "none", color: "#fff", cursor: "pointer",}} >
                                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }} onClick={(e)=>slectAsset('USDT')}>
                                                                <img src="https://cryptologos.cc/logos/tether-usdt-logo.png" alt={'USDT'} style={{ width: "35px", height: "35px" }} />
                                                                <span style={{ fontSize: "25px" }}>{'USDT'}</span>
                                                            </div>
                                                        </div>
                                                        </li>
                                                    </ul>
                                            

                                                
                                                )}
                                            </div>

                                            <div className="mt-5">
                                               
                                                <h4 className="mt-3">Enter Amount</h4>
                                                <input  type="text" className="form-control" placeholder="Enter amount" value={amount} onChange={(e)=>inputAmount(e.target.value)}
                                                style={{  background: "none", border: "1px solid #ccc", color: "#fff", padding: "10px",  width: "100%", fontSize: "16px", borderRadius: "5px", fontSize: "25px"}}
                                                />
                                            </div>

                                            <div className="text-center mt-3">
                                                <span className="text-warning">YOU RECEIVE</span>
                                                <h4>{kcoinAmount || '0'} K COIN</h4>
                                            </div>

                                            <div className="mt-5">
                                                <div>
                                                <span>Wallet : {wallet ? wallet.slice(0, 5) + '...' + wallet.slice(-5) : 'Connect Wallet'}</span>
                                                </div>
                                                <br></br>

                                                {connected ? (
                                                    isButton ? (
                                                        <button onClick={buyNow} className="btn">BUY NOW</button>
                                                    ) : (
                                                        <a  className="btn">Waiting..</a>
                                                    )
                                                ) : (
                                                    <a onClick={connectWallet} className="btn">CONNECT WALLET</a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                    </section>
                    <section id="about" className="about-area pt-130 pb-130">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <div className="about-img wow fadeInLeft" data-wow-delay=".2s">
                                        <img src="assets/img/logo/kcoinLogo.png" alt />
                                        <img src="assets/img/images/about_img02.png" alt className="img-two" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="about-content wow fadeInRight" data-wow-delay=".2s">
                                        <div className="section-title mb-30">
                                            <span className="sub-title">Who we are</span>
                                            <h2 className="title">The World’s <span>1st Coin</span> Platform Launched Before Its ICO.</h2>
                                        </div>
                                        <p>We are the world’s first ICO coin to launch our product and platform before the ICO itself. By building resources first and then launching the ICO, we ensure 99.9% certainty of success, making it highly valuable.</p>
                                        <a href="#" className="btn">Purchase Tokens</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* about-area-end */}
                    {/* partner-area */}
                    <div className="partner-area pb-130">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8">
                                    <div className="section-title text-center mb-10">
                                        <span className="sub-title">Our Speciality</span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="partner-wrap">
                                        <ul>
                                            <li><img src="assets/img/partner/bscscan.png" width={200} alt /></li>
                                            <li><img src="assets/img/partner/soureccode.png" alt  width={200}/></li>
                                            <li><img src="assets/img/partner/limitedSupply.png" alt  width={200}/></li>
                                            <li><img src="assets/img/partner/allocated.png"  width={200} alt /></li>
                                            <li><img src="assets/img/partner/ binanceBlockchain.png" alt  width={200} /></li>
                                            <li><img src="assets/img/partner/webbasedgame.png" alt width={200} /></li>
                                            <li><img src="assets/img/partner/Web3Wallet.png" width={200} alt /></li>
                                            <li><img src="assets/img/partner/noneminting.png" width={200} alt /></li>
                                            <li><img src="assets/img/partner/supply.png"  width={200} alt /></li>
                                            <li><img src="assets/img/partner/antidumping.png" width={200} alt /></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* partner-area-end */}
                    {/* choose-area */}
                    <section className="choose-area pb-130">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xl-6">
                                    <div className="section-title text-center mb-50">
                                        <span className="sub-title">why Choose us</span>
                                        <h2 className="title">Why choose our K COIN <span>Token</span></h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row choose-active">
                                <div className="col-lg-3">
                                    <div className="choose-item">
                                        <div className="choose-icon">
                                            <img src="assets/img/icon/choose_icon01.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Strong Web3 Ecosystem</a></h2>
                                            <p>K COIN is more than just a token—it’s part of a growing Web3 ecosystem, including a Web3 wallet, payment gateway, Web3 game, and social community.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="choose-item">
                                        <div className="choose-icon">
                                            <img src="assets/img/icon/choose_icon02.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#"> Fixed Supply of 510 Million</a></h2>
                                            <p>Pre-sale investors can acquire K COIN at the lowest price, maximizing potential returns before public launch.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="choose-item">
                                        <div className="choose-icon">
                                            <img src="assets/img/icon/choose_icon03.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Web3 Payment Gateway Integration</a></h2>
                                            <p>K COIN will power a secure and decentralized payment system, making crypto transactions seamless and efficient.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="choose-item">
                                        <div className="choose-icon">
                                            <img src="assets/img/icon/choose_icon04.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Utility in Web3 Gaming</a></h2>
                                            <p>Our upcoming Web3 game will integrate K COIN for in-game transactions, rewards, and NFT purchases, increasing token demand.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="choose-item">
                                        <div className="choose-icon">
                                            <img src="assets/img/icon/choose_icon02.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Decentralized Social Community</a></h2>
                                            <p>K COIN will be the core currency of our Web3-based social platform, enabling content rewards, tipping, and decentralized engagement.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="choose-item">
                                        <div className="choose-icon">
                                            <img src="assets/img/icon/choose_icon03.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Secure & Fast Transactions</a></h2>
                                            <p>Built on a high-performance blockchain, K Coin ensures fast, low-cost, and secure transactions for all users..</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="choose-item">
                                        <div className="choose-icon">
                                            <img src="assets/img/icon/choose_icon04.svg" alt />
                                        </div>
                                        <div className="choose-content">
                                            <h2 className="title"><a href="#">Future Exchange Listings</a></h2>
                                            <p>After the pre-sale, K COIN will be listed on major exchanges, ensuring liquidity and wider adoption.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="slide-progress" role="progressbar" aria-valuemin={0} aria-valuemax={100}>
                                <span className="slider__label sr-only" />
                            </div>
                        </div>
                    </section>
                    {/* choose-area-end */}
                    {/* chart-area */}
                    <section id="sales" className="chart-area chart-bg jarallax">
                        <div className="container">
                            <div className="chart-inner">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-lg-6 col-md-10 order-0 order-lg-2">
                                        <div className="chart-wrap wow fadeInRight" data-wow-delay=".2s">
                                            <img src="assets/img/images/chart.png" alt />
                                            <ul>
                                                <li>ICO: 10%</li>
                                                <li>Business Development: 10%</li>
                                                <li>Investor: 10%</li>
                                                <li>Exchnage : 30</li>
                                                <li>Legal &amp; Regulation:10%</li>
                                                <li>Community : 20%</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-10">
                                        <div className="chart-content wow fadeInLeft" data-wow-delay=".2s">
                                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link active" id="funding-tab" data-bs-toggle="tab" data-bs-target="#funding" type="button" role="tab" aria-controls="funding" aria-selected="true">Funding Allocation</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="token-tab" data-bs-toggle="tab" data-bs-target="#token" type="button" role="tab" aria-controls="token" aria-selected="false">Token Allocation</button>
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="myTabContent">
                                                <div className="tab-pane fade show active" id="funding" role="tabpanel" aria-labelledby="funding-tab">
                                                    <div className="chart-content-inner">
                                                        <h2 className="title">1 K COIN = {masterData.ico_current_price || '0'} USDT</h2>
                                                        <p>The World’s 1st ICO Platform That Offers Rewards and The platform helps investors to make easy to purchase and sell their tokens</p>
                                                        <a href="#buynow" className="btn">BUY NOW</a>
                                                    </div>
                                                </div>
                                                <div className="tab-pane fade" id="token" role="tabpanel" aria-labelledby="token-tab">
                                                    <div className="chart-content-inner">
                                                        <h2 className="title">1 USDT = {1/masterData.ico_current_price || '0'} K COIN</h2>
                                                        <p>The World’s 1st ICO Platform That Offers Rewards and The platform helps investors to make easy to purchase and sell their tokens</p>
                                                        <a href="#buynow" className="btn">BUY NOW</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* chart-area-end */}
                    {/* area-bg */}
                    <div className="area-bg">
                        {/* roadMap-area */}
                        <section id="roadmap" className="roadmap-area pt-130 pb-130">
                            <div className="container custom-container-two">
                                <div className="row justify-content-center">
                                    <div className="col-xl-5 col-lg-8">
                                        <div className="section-title text-center mb-60">
                                            <span className="sub-title">OUr Roadmap</span>
                                            <h2 className="title">K COIN Strategy and <br /> Project <span>Plan</span></h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="bt-roadmap_x">
                                            <div className="bt-roadmap-wrap">
                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2021 Q1</span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">Setting up the Kaym Coin Ecosystem</h4>
                                                        <span>Research Blockchain</span>
                                                        <span>Create Blue priny</span>
                                                        <span>Create Team</span>
                                                    </div>
                                                </div>
                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2022 - Q2</span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">Development</h4>
                                                        <span>Start Development</span>
                                                        <span>Improve Security</span>
                                                        <span>Fixing bug and testing</span>
                                                    </div>
                                                </div>
                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2022 – Q4</span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">Ecosystem Infrastructure Development and Launch</h4>
                                                        <span>Public on Mainnet launch</span>
                                                        <span>SubQuery Network Explorer and dApp</span>
                                                        <span>Point-in-time indexing</span>
                                                    </div>
                                                </div>
                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2023 – Q1</span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">Intialize game development</h4>
                                                        <span>Start Developement Game</span>
                                                        <span>Making interface</span>
                                                        <span>Plan for launching</span>
                                                    </div>
                                                </div>
                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2023 – Q3</span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">Developed Games</h4>
                                                        <span>Finish Development</span>
                                                        <span>Phase 1 Development complete</span>
                                                        <span>Start testing as user</span>
                                                    </div>
                                                </div>
                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2024 Q1 to Q4</span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">Waller and Gateway Development</h4>
                                                        <span>Develop web3 wallet</span>
                                                        <span>Develop Payment gateway</span>
                                                        <span>Launched Web3 Wallet and gateway</span>
                                                    </div>
                                                </div>
                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2025 Q1 to Q2 </span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">ICO and Pre-Sale</h4>
                                                        <span>Open Ico for public<br />Launching Pre-sale for holder </span>
                                                        <span></span>
                                                    </div>
                                                </div>
                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2025 Q3 </span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">Listing on cex</h4>
                                                        <span>Listing on 5 Exchange<br />Accepting for hotel booking and flight booking </span>
                                                        <span></span>
                                                    </div>
                                                </div>

                                                <div className="bt-roadmap-item">
                                                    <span className="roadmap-title">2025 Q4 </span>
                                                    <div className="roadmap-content">
                                                        <span className="dot" />
                                                        <h4 className="title">E-Shopping</h4>
                                                        <span>Use in online shopping<br />Buy and rent property with k coin </span>
                                                        <span>Use in Ride2luxury</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* roadMap-area-end */}
                        {/* document-area */}
                        <section className="document-area pt-60">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-lg-7 order-2 order-lg-0">
                                        <div className="document-img text-center wow fadeInUp" data-wow-delay=".2s">
                                            <img src="assets/img/images/walletScreen.png" alt />
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-7">
                                        <div className="document-content mt-50 wow fadeInRight" data-wow-delay=".2s">
                                            <div className="section-title mb-35">
                                                <span className="sub-title">Whitepaper</span>
                                                <h2 className="title">Read K COIN <span>Documents</span></h2>
                                            </div>
                                            <ul className="document-list">
                                                <li>White Paper</li>
                                                <li>Privaci &amp; Policy</li>
                                                <li>Terms Of Coin Sale</li>
                                                <li>One Pager</li>
                                            </ul>
                                            <a href="https://www.kaymcoin.com/wp-content/uploads/2023/12/Kaym-Coin-White-Paper.pdf" className="btn">Download Doc</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* document-area-end */}
                    </div>
                    {/* area-bg-end */}
                    {/* team-area */}
                    <section className="team-area pt-130">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xl-6">
                                    <div className="section-title text-center mb-70">
                                        <h2 className="title">Our <span>Projects</span></h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-xl-4 col-md-4 col-sm-6">
                                    <div className="team-item">
                                        <div className="team-thumb" >
                                            <img src="assets/img/team/videoGame.avif" alt  width={200}/>
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Online Multiplayer Game</h2>
                                            <span><a href="https://fastpredict.kaymcoin.in/login" target="blank" className="btn btn-primary btn-sm">VIEW</a></span>
                                          
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4 col-sm-6">
                                    <div className="team-item">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/cryptoWallet.png" alt  width={200} />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Web 3 Wallet</h2>
                                            <span><a href="https://wallet.kaymcoin.com/" target="blank" className="btn btn-primary btn-sm">VIEW</a></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4 col-sm-6">
                                    <div className="team-item">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/cryptoGateway.jpg" width={200}  alt />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Payment Solution</h2>
                                            <span><a href="https://zipwallet.net/" target="blank" className="btn btn-primary btn-sm">VIEW</a></span>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-xl-4 col-md-4 col-sm-6">
                                    <div className="team-item">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/hotel.jpg" width={200}  alt />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Booking Hotel</h2>
                                            <span className="text-warning">Comming Soon</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-4 col-md-4 col-sm-6">
                                    <div className="team-item">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/travel.avif" width={200}  alt />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">Booking Flight</h2>
                                            <span className="text-warning">Comming Soon</span>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-xl-4 col-md-4 col-sm-6">
                                    <div className="team-item">
                                        <div className="team-thumb">
                                            <img src="assets/img/team/shoppingImage.png" width={200}  alt />
                                        </div>
                                        <div className="team-content">
                                            <h2 className="title">E-commerce</h2>
                                            <span className="text-warning">Comming Soon</span>
                                        </div>
                                    </div>
                                </div>
                              
                            </div>
                        </div>
                    </section>
                    {/* team-area-end */}
                    {/* contact-area */}
                    <section id="contact" className="contact-area pt-70 pb-110">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8">
                                    <div className="section-title text-center mb-70">
                                        <span className="sub-title">Contact</span>
                                        <h2 className="title"><span>Contact</span> ICO Crypto</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="contact-form-wrap">
                                <form action="#">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-grp">
                                                <input type="text" placeholder="Enter your Name" required />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-grp">
                                                <input type="email" placeholder="Enter you email" required />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-grp">
                                        <textarea name="massage" placeholder="Enter your massage" defaultValue={""} />
                                    </div>
                                    <div className="submit-btn text-center">
                                        <button type="submit" className="btn">Send Massage</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                    {/* contact-area-end */}
                </main>
                {/* main-area-end */}
                {/* footer-area */}
                <footer>
                    <div className="footer-area">
                        <div className="container">
                            <div className="footer-scroll-wrap">
                                <button className="scroll-to-target" data-target="html"><i className="fas fa-arrow-up" /></button>
                            </div>
                            <div className="footer-top">
                                <div className="row">
                                    <div className="col-xl-3 col-lg-4 col-md-6">
                                        <div className="footer-widget wow fadeInUp" data-wow-delay=".2s">
                                            <a href="/index" className="f-logo"><img src="assets/img/logo/kcoinLogo.png" alt  width={100}/></a>
                                            <div className="footer-content">
                                                <p>A new way to make the invest easy, reliable and 100% secure.</p>
                                                <ul className="footer-social">
                                                    <li><a href="https://www.youtube.com/channel/UCd39yTqnDn2DbFwC01lp3uw"><i className="fab fa-youtube" /></a></li>
                                                    <li><a href="https://twitter.com/kaymcoin"><i className="fab fa-twitter" /></a></li>
                                                    <li><a href="https://www.facebook.com/kaymcoin"><i className="fab fa-facebook-f" /></a></li>
                                                    <li><a href="https://www.instagram.com/kaymcoin/"><i className="fab fa-instagram" /></a></li>
                                                    <li><a href="https://t.me/s/kaymcoindigitalasset"><i className="fab fa-telegram" /></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-5 col-sm-6">
                                        <div className="footer-widget  wow fadeInUp" data-wow-delay=".4s">
                                            <h4 className="fw-title">Useful Links</h4>
                                            <div className="footer-link">
                                                <ul>
                                                    <li><a href="https://www.instagram.com/kaymcoin/">Contact us</a></li>
                                                    <li><a href="https://www.kaymcoin.com/">How it Works</a></li>
                                                    <li><a href="https://bscscan.com/address/0x5D26acBA14e4840cbce7B3504B90bb9B9f1Ca99B">Explore</a></li>
                                                    <li><a href="#">Terms &amp; Services</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-2 col-lg-3 col-sm-6">
                                        <div className="footer-widget wow fadeInUp" data-wow-delay=".6s">
                                            <h4 className="fw-title">Community</h4>
                                            <div className="footer-link">
                                                <ul>
                                                    <li><a href="#">Help Center</a></li>
                                                    <li><a href="https://zipwallet.net/">Partners</a></li>
                                                    <li><a href="#">Blog</a></li>
                                                    <li><a href="#">Newsletters</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6">
                                        <div className="footer-widget wow fadeInUp" data-wow-delay=".8s">
                                            <h4 className="fw-title">Subscribe Newsletter</h4>
                                            <div className="footer-newsletter">
                                                <p>Join our news telegram to get latest update</p>
                                               <h1> <a href="https://t.me/s/kaymcoindigitalasset" type="submit"><i className="fas fa-paper-plane" /></a></h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer-bottom">
                                <div className="row align-items-center">
                                    <div className="col-lg-6">
                                        <div className="copyright-text">
                                            <p>Copyright © 2023. All Rights Reserved K COIN</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 d-none d-sm-block">
                                        <div className="footer-menu">
                                            <ul>
                                                <li><a href="#">Terms and conditions</a></li>
                                                <li><a href="#">Privacy policy</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {/* footer-area-end */}
            </div>
           
        </>
        
    )
}

export default Index